import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { ClusterService, OidcService, OrganisationService } from '@fry-it/risr-core';
import { CheckService, SetupAppService } from '@fry/upgrade/route.service';

/**
 * Guard that initializes the application
 * @returns A promise that resolves when initialization is complete
 */
export const initGuard: CanActivateFn = async (
) => {
  const setupApp: any = inject(SetupAppService);
  const oidc: OidcService = inject(OidcService);
  const cluster: ClusterService = inject(ClusterService);
  const organisation: OrganisationService = inject(OrganisationService);
  const check: any = inject(CheckService);

  try {
    await check.detectConnectivity();
    await oidc.init({ relogin: true });
    await cluster.loadProfileOrganisations();
    await organisation.fetchOrganisation();
    await setupApp.initApp();
    return true;
  } catch (err) {
    console.error('Initialization failed:', err);
    return false;
  }
};
